import { FacetsConfig } from '../../../../../store/features/discovery';

export function isFilterEnabled(config?: FacetsConfig) {
  return !!config && Object.values(config).some((value) => value);
}
